const homelist = {
  jikiba_info: {
    id: "jikiba",
    name: "食場分譲地",
    subname: "コンフォートニュータウン食場",
    mainimg: "images/jikiba/main.gif",
    droneimg: "images/jikiba/drone.jpg",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d841.8376096391748!2d130.18088423562693!3d32.4365534269086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x353fef21e38a8205%3A0xa7e62af428db329b!2z44CSODYzLTAwNDYg54aK5pys55yM5aSp6I2J5biC5LqA5aC055S66aOf5aC077yW77yY77yR!5e0!3m2!1sja!2sjp!4v1656673507649!5m2!1sja!2sjp",
    section: ["jikiba5", "jikiba4", "jikiba3", "jikiba2"],
    sectionname: [
      "食場分譲地V 第5期分譲地",
      "食場分譲地Ⅳ 第4期分譲地",
      "食場分譲地Ⅲ 第3期分譲地",
      "食場分譲地Ⅱ 第2期分譲地",
    ],
    sectionimg: [
      "images/jikiba/jikiba4.gif",
      "images/jikiba/jikiba3.gif",
      "images/jikiba/jikiba2.gif",
    ],
  },
  jikiba2: {
    jikiba2b: {
      id: "jikiba2b",
      name: "食場モデル住宅Ⅱ-B",
      price: 2900,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場679-2",
      madori: "3LDK+",
      tatemono: 34.94,
      tochi: 64.7,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "リビング"],
        ["04.jpg", "リビング"],
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      vrimg: [
        ["vr01.jpg", "リビング"],
        ["vr02.jpg", "キッチン"],
        ["vr03.jpg", "ファミリークローク"],
        ["vr04.jpg", "寝室"],
        ["vr05.jpg", "浴室"],
        ["vr06.jpg", "脱衣室"],
        ["vr07.jpg", "ホール"],
        ["vr08.jpg", "玄関"],
        ["vr09.jpg", "階段"],
        ["vr10.jpg", "2F子供室"],
        ["vr11.jpg", "2F洋室"],
      ],
      archive: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "リビング"],
        ["04.jpg", "リビング"],
      ],
      maincopy: "シンボルツリーと四季を共に暮らす家",
      contents:
        "脱衣室の前に広いファミリークロークがあることで、家族全員の衣装を1か所にまとめて収納できます。また、寝室が1階にあるので平屋感覚で生活できます。",
      detail:
        "●所在地／天草市亀場町食場679-2●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和4年4月●販売戸数／1戸●木造2階建(軸組み工法)●間取り／3LDK+書斎●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（4台）",
    },
  },
  jikiba3: {
    jikiba3c: {
      id: "jikiba3c",
      name: "食場モデル住宅Ⅲ-C",
      price: "2800",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場681-7",
      madori: "3LDK",
      tatemono: 28.3,
      tochi: 76.4,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "寝室"],
        ["04.jpg", "洋室"],
        ["05.jpg", "洋室"],
        ["06.jpg", "トイレ"],
        ["07.jpg", "浴室"],
        ["08.jpg", "キッチン"],
        ["09.jpg", "リビング"],
        ["madori.jpg", "リビング"],
      ],
      archive: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "寝室"],
        ["04.jpg", "洋室"],
        ["05.jpg", "洋室"],
        ["06.jpg", "トイレ"],
        ["07.jpg", "浴室"],
        ["08.jpg", "キッチン"],
        ["09.jpg", "リビング"],
      ],
      maincopy: "開放感あふれる吹き抜けが魅力の平屋住宅です！",
      contents:
        "住みやすくて人気の平屋住宅。吹き抜けのある開放感あふれる住宅です。",
      detail:
        "●所在地／天草市亀場町食場681-7●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和4年3月●販売戸数／1戸●木造1階建(軸組み工法)●間取り／3LDK●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・オール電化・LED照明・食器洗い機・カップボード・Low-E複層ガラス・浴室換気暖房乾燥機・エアコン(2台)・駐車場(3台) ",
    },
    jikiba3d: {
      id: "jikiba3d",
      name: "食場モデル住宅Ⅲ-D",
      price: 2980,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場681-8",
      madori: "4LDK",
      tatemono: 33.46,
      tochi: 76.6,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "キッチン"],
        ["madori1.jpg", "リビング"],
      ],
      vrimg: [
        ["vr01.jpg", "リビング"],
        ["vr02.jpg", "キッチン"],
        ["vr03.jpg", "寝室"],
        ["vr04.jpg", "和室"],
        ["vr05.jpg", "玄関"],
        ["vr06.jpg", "ホール"],
        ["vr07.jpg", "子供室"],
        ["vr08.jpg", "脱衣室"],
      ],
      archive: [["01.jpg", "リビング"]],
      maincopy: "広敷地と部屋数が魅力の平屋住宅です！",
      contents:
        "住みやすくて人気の平屋が完成しました。玄関に一歩入ると、吹き抜けと長い廊下が建物の開放感あふれる奥行を感じさせてくれます。",
      detail:
        "●所在地／天草市亀場町食場681-8●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和4年3月●販売戸数／1戸●木造1階建(軸組み工法)●間取り／4LDK●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（4台）",
    },
    jikiba3g: {
      id: "jikiba3g",
      name: "食場モデル住宅Ⅲ-G",
      price: 2800,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場681-10 食場分譲地内",
      madori: "3LDK",
      tatemono: 32.48,
      tochi: 61.77,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "玄関"],
        ["05.jpg", "外観"],
        ["06.jpg", "カウンター"],
        ["07.jpg", "ベランダ"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["madori.jpg", "間取り"],
      ],
      vrimg: [
        ["vr01.jpg", "洋室"],
        ["vr02.jpg", "洋室"],
        ["vr03.jpg", "洋室"],
        ["vr04.jpg", "ベランダ"],
        ["vr05.jpg", "2F"],
        ["vr06.jpg", "階段"],
        ["vr07.jpg", "浴室"],
        ["vr08.jpg", "脱衣室"],
        ["vr09.jpg", "ホール"],
        ["vr10.jpg", "玄関"],
        ["vr11.jpg", "キッチン"],
      ],
      archive: [
        ["01.jpg", "リビング"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "玄関"],
        ["05.jpg", "外観"],
        ["09.jpg", "洋室"],
      ],
      maincopy: "次世代型床下冷暖房システム導入！",
      contents:
        "オンレイECO床暖システムを1階部分に採用。脱衣所や廊下、トイレ、玄関まで、部屋の温度を均一にします。オンレイECO床暖システムについての詳細は<a href='https://ecoyukadan.jp/'>こちら</a>",
      detail:
        "●所在地／天草市亀場町食場681-10●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和3年5月●販売戸数／1戸●木造2階建(軸組み工法)●間取り／3LDK●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・オール電化・LED照明・食器洗い機・Low-E複層ガラス・浴室換気暖房乾燥機・エアコン(2台)・駐車場(3台）",
    },
    jikiba3h: {
      id: "jikiba3h",
      name: "食場モデル住宅Ⅲ-H",
      price: 3000,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場681 食場分譲地内",
      madori: "4LDK",
      tatemono: 35.42,
      tochi: 64.7,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "和室"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "洗面"],
        ["06.jpg", "浴室"],
        ["07.jpg", "階段・トイレ"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["10.jpg", "洋室"],
        ["11.jpg", "玄関"],
        ["12.jpg", "キッチン"],
        ["13.jpg", "玄関"],
        ["madori.jpg", "間取り図"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関"],
        ["vr02.jpg", "ロビー"],
        ["vr03.jpg", "リビング"],
        ["vr04.jpg", "キッチン"],
        ["vr05.jpg", "脱衣室"],
        ["vr06.jpg", "浴室"],
        ["vr07.jpg", "和室"],
        ["vr08.jpg", "洋室"],
        ["vr09.jpg", "洋室"],
        ["vr10.jpg", "洋室"],
      ],
      archive: [
        ["01.jpg", "リビング"],
        ["02.jpg", "和室"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "洗面"],
        ["06.jpg", "浴室"],
        ["07.jpg", "階段・トイレ"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["10.jpg", "洋室"],
        ["11.jpg", "玄関"],
        ["12.jpg", "キッチン"],
        ["13.jpg", "玄関"],
      ],
      maincopy: "家族の距離が近づく、風通しのよい住まい。",
      contents:
        "リビングダイニングと和室がひとつなぎになる間取りで、家族全員が同じ空間でゆっくりとくつろげます。",
      detail:
        "所在地／天草市亀場町食場６８１－１１●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和４年７月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽●主な設備／九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・駐車場（３台）",
      equip:
        "九州電力・オール電化・LED照明・食器洗い機・Low-E複層ガラス・エアコン(2台)・駐車場(3台）",
    },
  },
  jikiba4: {
    jikiba4a: {
      id: "jikiba4a",
      name: "食場モデル住宅Ⅳ-A",
      price: "",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場685-1 食場分譲地内",
      madori: "4LDK",
      tatemono: 35.76,
      tochi: 64.61,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "洋室"],
        ["05.jpg", "リビング+洋室"],
        ["06.jpg", "浴室"],
        ["07.jpg", "玄関"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["10.jpg", "洋室"],
        ["madori1.jpg", "間取り図"],
        ["madori2.jpg", "間取り図"],
      ],
      vrimg: [
        ["vr01.jpg", "リビング"],
        ["vr02.jpg", "キッチン"],
        ["vr03.jpg", "リビング"],
        ["vr04.jpg", "ホール"],
        ["vr05.jpg", "洋室"],
        ["vr06.jpg", "浴室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "洋室"],
        ["vr09.jpg", "洋室"],
      ],
      archive: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "洋室"],
        ["05.jpg", "リビング+洋室"],
      ],
      maincopy: "家族の距離が近づく、風通しのよい住まい。",
      contents:
        "リビングダイニングと洋室がひとつなぎになる間取りで、家族全員が同じ空間でゆっくりとくつろげます。",
      detail:
        "所在地／天草市亀場町食場６８５－１●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和４年11月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・駐車場（4台）",
    },
    jikiba4b: {
      id: "jikiba4b",
      name: "食場モデル住宅Ⅳ-B",
      price: "3200",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場685-8 食場分譲地内",
      madori: "4LDK",
      tatemono: 37.46,
      tochi: 71.34,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "和室"],
        ["04.jpg", "浴室"],
        ["05.jpg", "玄関"],
        ["06.jpg", "収納"],
        ["07.jpg", "洋室"],
        ["08.jpg", "洋室"],
      ],
      vrimg: [
        ["vr01.jpg", "リビング"],
        ["vr02.jpg", "和室"],
        ["vr03.jpg", "キッチン"],
        ["vr04.jpg", "ホール"],
        ["vr05.jpg", "浴室"],
        ["vr06.jpg", "洋室"],
        ["vr07.jpg", "玄関"],
        ["vr08.jpg", "玄関"],
        ["vr09.jpg", "洋室"],
      ],
      archive: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "和室"],
        ["04.jpg", "浴室"],
        ["05.jpg", "玄関"],
        ["06.jpg", "収納"],
        ["07.jpg", "洋室"],
        ["08.jpg", "洋室"],
      ],
      maincopy: "優しい佇まいで家族を包み込んでくれる住まい",
      contents:
        "エレガントな内装が優しく家族を迎え入れます。さらに天井が高く開放的なリビングが、居心地の良さを感じさせてくれます。リビングとつながる和室やたくさんの収納スペース、そして寝室が1階にあることにより使い勝手の良い間取りになりました。",
      detail:
        "所在地／天草市亀場町食場６８５－８●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和５年３月予定●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（4台）",
    },
  },
  jikiba5: {
    jikiba5a: {
      id: "jikiba5a",
      name: "食場モデル住宅V-A",
      price: "3200",
      spprice: "3200",
      category: "住宅",
      status: 1, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "4LDK",
      tatemono: 36.35,
      tochi: 57.85,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "脱衣所"],
        ["05.jpg", "浴室"],
        ["06.jpg", "玄関"],
        ["07.jpg", "洋室"],
        ["08.jpg", "和室"],
        ["09.jpg", "洋室"],
        ["madori1.jpg", "間取1F"],
        ["madori2.jpg", "間取2F"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関"],
        ["vr02.jpg", "キッチン"],
        ["vr03.jpg", "リビング"],
        ["vr05.jpg", "洗面・脱衣所"],
        ["vr06.jpg", "和室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "洋室"],
        ["vr09.jpg", "洋室"],
      ],
      archive: [],
      maincopy: "独立した和室と、1階寝室で平屋感覚で暮らせる家",
      contents:
        "独立した和室があり、また1階に寝室を創ったことで平屋感覚で住める、暮らしやすい家です。",
      detail:
        "所在地／天草市亀場町食場６８８－４●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和５年６月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（２台）",
    },
    jikiba5b: {
      id: "jikiba5b",
      name: "食場モデル住宅V-B",
      price: "3200",
      spprice: "3200",
      category: "住宅",
      status: 1, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "4LDK",
      tatemono: 34.53,
      tochi: 55.82,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "リビング"],
        ["05.jpg", "和室"],
        ["06.jpg", "浴室・脱衣所"],
        ["07.jpg", "洋室"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["10.jpg", "洋室"],
        ["11.jpg", "クローゼット"],
        ["12.jpg", "玄関ホール"],
      ],
      vrimg: [
        ["vr02.jpg", "リビング"],
        ["vr01.jpg", "キッチン"],
        ["vr04.jpg", "和室"],
        ["vr03.jpg", "浴室"],
        ["vr05.jpg", "玄関"],
        ["vr06.jpg", "洋室"],
        ["vr07.jpg", "洋室"],
      ],
      archive: [],
      maincopy: "広いリビングと続き間の和室。一階寝室で平屋のような心地よさ",
      contents: "",
      detail:
        "●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・プロパンガス（長井商事）・エコキュート・ガスコンロ・食器洗い機・リンナイ ガス衣類乾燥機（乾太くん）・浴室乾燥機 暖房便座ウォシュレット・駐車場（３台）",
    },
    jikiba5c: {
      id: "jikiba5c",
      name: "食場モデル住宅V-C",
      price: "3200",
      spprice: "3200",
      category: "住宅",
      status: 1, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-6 食場分譲地内",
      madori: "4LDK",
      tochi: 57.56,
      tatemono: 36.2,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "和室"],
        ["06.jpg", "洋室"],
        ["07.jpg", "洋室"],
        ["08.jpg", "玄関ホール"],
        ["madori1.jpg", "1F平面図"],
        ["madori2.jpg", "2F平面図"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関ホール"],
        ["vr02.jpg", "リビング"],
        ["vr03.jpg", "リビング"],
        ["vr04.jpg", "キッチン"],
        ["vr05.jpg", "浴室"],
        ["vr06.jpg", "和室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "洋室"],
      ],
      archive: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "洋室"],
        ["05.jpg", "リビング+洋室"],
      ],
      maincopy: "ゆとりある空間でくつろぎの生活を",
      contents: "",
      detail:
        "●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和５年８月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・浴室乾燥機・駐車場(３台)",
    },
    jikiba5d: {
      id: "jikiba5d",
      name: "食場モデル住宅V-D",
      price: "3200",
      spprice: "3200",
      category: "住宅",
      status: 1, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-6 食場分譲地内",
      madori: "4LDK",
      tochi: 60.77,
      tatemono: 34.53,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "リビング"],
        ["09.jpg", "和室"],
        ["10.jpg", "和室"],
        ["05.jpg", "浴室"],
        ["06.jpg", "玄関ホール"],
        ["07.jpg", "洋室"],
        ["08.jpg", "洋室"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関ホール"],
        ["vr02.jpg", "キッチン"],
        ["vr03.jpg", "リビング"],
        ["vr04.jpg", "リビング"],
        ["vr10.jpg", "和室"],
        ["vr05.jpg", "洗面・脱衣所"],
        ["vr06.jpg", "浴室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "洋室"],
        ["vr09.jpg", "洋室"],
      ],
      archive: [
        ["01.jpg", "キッチン"],
        ["02.jpg", "リビング"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "洋室"],
        ["05.jpg", "リビング+洋室"],
      ],
      maincopy: "家族団らんを和洋の広いリビングスペースで",
      contents: "",
      detail:
        "所在地／天草市亀場町食場６８７－７●交通／最寄りのバス停：友尻バス停徒歩３分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和６年３月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員５mアスファルト舗装●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（２台）",
    },
    jikiba5e: {
      id: "jikiba5e",
      name: "食場V-E",
      price: "2900",
      category: "住宅",
      status: 3, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "3LDK",
      tochi: 54.92,
      tatemono: "31.62",
      mainimg: "main.jpg",
      thumbnail: [
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      maincopy: "暮らしやすい立地で、理想のマイホームを",
      contents:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
      detail:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
    },
    jikiba5f: {
      id: "jikiba5f",
      name: "食場V-F",
      price: "2900",
      category: "住宅",
      status: 3, //1:販売中 0:売約済 2:建設中 3:オーダー
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "3LDK",
      tochi: 55.33,
      tatemono: "31.35",
      mainimg: "main.jpg",
      thumbnail: [
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      maincopy: "暮らしやすい立地で、理想のマイホームを",
      contents:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
      detail:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
    },
    jikiba5g: {
      id: "jikiba5g",
      name: "食場V-G",
      price: "2900",
      category: "住宅",
      status: 3, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "3LDK",
      tochi: 55.38,
      tatemono: "31.28",
      mainimg: "main.jpg",
      thumbnail: [
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      maincopy: "暮らしやすい立地で、理想のマイホームを",
      contents:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
      detail:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
    },
    jikiba5h: {
      id: "jikiba5h",
      name: "食場V-H",
      price: "2900",
      category: "住宅",
      status: 3, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "3LDK",
      tochi: 59.87,
      tatemono: "30.82",
      mainimg: "main.jpg",
      thumbnail: [
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      maincopy: "暮らしやすい立地で、理想のマイホームを",
      contents:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
      detail:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
    },
    jikiba5i: {
      id: "jikiba5i",
      name: "食場V-I",
      price: "2900",
      category: "住宅",
      status: 3, //1:販売中 0:売約済 2:建設中
      address: "天草市亀場町食場688-4 食場分譲地内",
      madori: "3LDK",
      tochi: 68.27,
      tatemono: "31.26",
      mainimg: "main.jpg",
      thumbnail: [
        ["madori1.jpg", "間取り1F"],
        ["madori2.jpg", "間取り2F"],
      ],
      maincopy: "暮らしやすい立地で、理想のマイホームを",
      contents:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
      detail:
        "弊社がおすすめするプランをベースとして、お客様のご要望に合わせてカスタマイズ可能な新築住宅です。",
    },
  },
  kitahara_info: {
    id: "kitahara",
    name: "北原町分譲地",
    mainimg: "images/kitahara/kitahara1.gif",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1000.7941782544615!2d130.18527716389514!3d32.46582221456143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd553dc1b2ef7270b!2zMzLCsDI3JzU2LjUiTiAxMzDCsDExJzA4LjAiRQ!5e0!3m2!1sja!2sjp!4v1663066781165!5m2!1sja!2sjp",
    section: ["kitahara1"],
    sectionname: ["北原町分譲地"],
    sectionimg: ["images/kitahara/kitahara1.gif"],
  },
  kitahara1: {
    kitahara1a: {
      id: "kitahara1a",
      name: "北原町94-1",
      price: 2900,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "3LDK",
      tatemono: "--",
      tochi: 65.5,
      mainimg: "main.gif",
      thumbnail: [],
      archive: [],
      maincopy: "シンボルツリーと四季を共に暮らす家",
      contents:
        "脱衣室の前に広いファミリークロークがあることで、家族全員の衣装を1か所にまとめて収納できます。また、寝室が1階にあるので平屋感覚で生活できます。",
      detail:
        "●所在地／天草市亀場町食場679-2●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和4年4月●販売戸数／1戸●木造2階建(軸組み工法)●間取り／3LDK+書斎●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（4台）",
    },
    kitahara1b: {
      id: "kitahara1b",
      name: "北原町モデル住宅B",
      price: 3600,
      spprice: 3600,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "北原町7-4",
      madori: "4LDK",
      tatemono: 35.55,
      tochi: 60.37,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "玄関"],
        ["06.jpg", "洋室"],
        ["07.jpg", "洋室"],
        ["08.jpg", "浴室"],
        ["09.jpg", "脱衣室"],
        ["10.jpg", "洋室"],
        ["11.jpg", "ロビー"],
        ["12.jpg", "洋室"],
        ["madori1.jpg", "間取り図"],
        ["madori2.jpg", "間取り図"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関"],
        ["vr02.jpg", "リビング"],
        ["vr03.jpg", "リビング"],
        ["vr04.jpg", "キッチン"],
        ["vr05.jpg", "2F洋室"],
        ["vr06.jpg", "2Fロビー"],
        ["vr07.jpg", "2Fロビー"],
        ["vr08.jpg", "階段"],
        ["vr09.jpg", "浴室"],
        ["vr10.jpg", "脱衣室"],
        ["vr11.jpg", "洗面"],
      ],
      maincopy: "回遊動線で毎日の家事が楽になる住まい",
      contents:
        "家事動線を考えた間取りと天井の高い開放的なリビング。さらに寝室を1階に設けることで、家族みんなが暮らしやすい住まいになりました。収納スペースが多いのも、この家の魅力です。",
      detail:
        "●交通／最寄りのバス停：馬場バス停徒歩５分●建築確認番号／天第２１００９８号●用途地域／第1種中高層住居専用地域●地目／宅地●取引形態／売主●竣工／令和４年８月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員６m●主な設備／市上下水道",
      equip:
        "九州電力・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（4台）",
    },
    kitahara1c: {
      id: "kitahara1c",
      name: "北原町モデル住宅C",
      price: 3600,
      spprice: 3600,
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "北原町7-8",
      madori: "4LDK",
      tatemono: 35.32,
      tochi: 59.59,
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "キッチン"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "玄関"],
        ["06.jpg", "洋室"],
        ["07.jpg", "洋室"],
        ["08.jpg", "浴室"],
        ["09.jpg", "和室"],
        ["madori1.jpg", "間取1F"],
        ["madori2.jpg", "間取2F"],
      ],
      vrimg: [
        ["vr01.jpg", "玄関"],
        ["vr02.jpg", "リビング"],
        ["vr03.jpg", "キッチン"],
        ["vr04.jpg", "洋室"],
        ["vr05.jpg", "洋室"],
        ["vr06.jpg", "浴室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "和室"],
      ],
      maincopy: "木の温かみ感じる、心地よい住まい",
      contents:
        "木の温かみを感じる梁が印象的な住まいです。高い天井に採光窓を備え、明るく心地よい住まいです。寝室が1階にあるので平屋感覚で生活できます。",
      detail:
        "●交通／最寄りのバス停：馬場バス停徒歩５分●建築確認番号／天第2200185号●用途地域／第1種中高層住居専用地域●地目／宅地●取引形態／売主●●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員６m●主な設備／市上下水道",
      equip:
        "九州電力・エコキュート・エアコン（1台）・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・駐車場（3台）",
    },
    kitahara1d: {
      id: "kitahara1d",
      name: "北原町モデル住宅D",
      price: 3600,
      spprice: "",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市北原町7番3-2",
      madori: "4LDK",
      tatemono: "35.98",
      tochi: "55.68",
      mainimg: "main.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "リビング"],
        ["03.jpg", "リビング"],
        ["04.jpg", "キッチン"],
        ["05.jpg", "玄関"],
        ["06.jpg", "洗面脱衣所"],
        ["07.jpg", "浴室"],
        ["08.jpg", "洋室"],
        ["09.jpg", "洋室"],
        ["10.jpg", "リビング"],
        ["madori1.jpg", "間取1F"],
        ["madori2.jpg", "間取2F"],
      ],
      vrimg: [
        ["vr01.jpg", "リビング"],
        ["vr02.jpg", "リビング"],
        ["vr03.jpg", "キッチン"],
        ["vr04.jpg", "玄関"],
        ["vr05.jpg", "洋室"],
        ["vr06.jpg", "浴室"],
        ["vr07.jpg", "洋室"],
        ["vr08.jpg", "和室"],
      ],
      maincopy: "眺めのいい2階リビングで快適な家族時間を",
      contents:
        "眺めのいい2階リビングが特徴的な住宅です。あたたかな陽射しと自然を感じながら、快適な家族時間を過ごせます。",
      detail:
        "●所在地／天草市北原町７番３－２号●交通／最寄りのバス停：馬場バス停徒歩５分●建築確認番号／天第２２００５６号●用途地域／第1種中高層住居専用地域●地目／宅地●取引形態／売主●竣工／令和５年４月●販売戸数／１戸●木造２階建（軸組み工法）●間取り／４ＬＤＫ●道路／幅員６m●主な設備／市上下水道・九州電力・エコキュート・暖房便座ウォシュレット・ＩＨクッキングヒーター・食器洗い機・浴室乾燥機・駐車場（３台）",
      equip:
        "九州電力・エコキュート・エアコン（1台）・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・駐車場（3台）",
    },
  },
  kamikawahara1: {
    kamikawahara1c: {
      id: "kamikawahara1c",
      name: "上川原モデル住宅C",
      price: "3200",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "天草市本渡町本渡1902-7",
      madori: "4LDK",
      tatemono: 37.73,
      tochi: 77.26,
      mainimg: "main.jpg",
      headimg: "12.jpg",
      thumbnail: [
        ["01.jpg", "リビング"],
        ["02.jpg", "キッチン"],
        ["03.jpg", "寝室"],
        ["04.jpg", "洋室"],
        ["05.jpg", "洋室"],
        ["06.jpg", "トイレ"],
        ["07.jpg", "浴室"],
        ["08.jpg", "キッチン"],
        ["09.jpg", "リビング"],
        ["madori.jpg", "間取り図"],
      ],
      archive: [
        ["01.jpg", "リビング"],
        ["02.jpg", "玄関"],
        ["03.jpg", "寝室"],
        ["04.jpg", "脱衣室"],
        ["05.jpg", "キッチン"],
        ["06.jpg", "浴室"],
        ["07.jpg", "洋室"],
        ["08.jpg", "洋室"],
        ["09.jpg", "シューズクローク"],
        ["09.jpg", "ホール・洗面"],
        ["10.jpg", "玄関・階段"],
        ["11.jpg", "リビング"],
        ["12.jpg", "リビング"],
      ],
      maincopy: "開放感あふれる吹き抜けが魅力の平屋住宅です！",
      contents:
        "住みやすくて人気の平屋住宅。吹き抜けのある開放感あふれる住宅です。",
      detail:
        "●所在地／天草市亀場町食場681-7●交通／最寄りのバス停：友尻バス停徒歩3分●都市計画／都市計画区域外●用途地域／指定なし●地目／宅地●取引形態／売主●竣工／令和4年3月●販売戸数／1戸●木造1階建(軸組み工法)●間取り／3LDK●道路幅員／5ｍ●上水道／市水道●排水／合併浄化槽",
      equip:
        "九州電力・オール電化・LED照明・食器洗い機・カップボード・Low-E複層ガラス・浴室換気暖房乾燥機・エアコン(2台)・駐車場(3台) ",
    },
  },
  model: {
    model1: {
      id: "model1",
      name: "モデル住宅B",
      price: "3200",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "3LDK",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "10.jpg",
      thumbnail: [],
      archive: [
        [
          "01.jpg",
          "広々とした吹き抜けは、光を取り込み明るい空間をつくります。",
        ],
        [
          "02.jpg",
          "キッチンからは、リビング・ダイニング全体を見渡すことができます。",
        ],
        ["03.jpg", "光を通すオープンスタイルの階段"],
        ["04.jpg", "広々とした玄関には、使いやすい収納スペースを。"],
        ["05.jpg", "システムバスも完備。"],
        ["06.jpg", "リビング"],
        ["07.jpg", "リビング"],
        ["08.jpg", "リビング"],
        ["09.jpg", "吹き抜け・採光窓"],
        ["10.jpg", "リビング"],
      ],
      maincopy: "光と会話が巡る家",
      contents:
        "家族との会話が弾み、生活が楽しくなるような住まいを目指しました。2階とのつながりを意識し、リビングに吹き抜けを設け、家中どこにいても家族のぬくもりが感じられるような明るい住まいになりました。2階ホール、寝室からは海を眺めることもできます。 ",
      detail: "",
      equip:
        "省エネガス給湯器・暖房便座ウォシュレット・ガスコンロ・食器洗い機・駐車場（3台）",
    },
    model2: {
      id: "model2",
      name: "モデル住宅A",
      price: "",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "3LDK",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "10.jpg",
      thumbnail: [],
      archive: [
        [
          "01.jpg",
          "ゆったりとした時間をすごせるダイニング。外にはウッドデッキがあります。",
        ],
        ["02.jpg", "対面型のシステムキッチン。"],
        ["03.jpg", "壁面にも収納スペースがあります。"],
        ["04.jpg", "寝室にはウォークインクローゼットを用意。"],
        ["05.jpg", "洗面・浴室周りの収納も豊富。"],
        ["06.jpg", ""],
        ["07.jpg", ""],
        ["08.jpg", ""],
        ["09.jpg", ""],
        ["10.jpg", ""],
      ],
      maincopy: "暮らしによりそう家",
      contents:
        "生活動線を意識した設計で、「暮らしやすさ」の実現を目指しました。リビング／ダイニングは、壁面収納にもなっている仕切りで広さと落ち着きあるプライベートな空間を両立させています。豊富な収納を備えており、快適に過ごせる住まいとなっています。 ",
      detail: "",
      equip:
        "オール電化・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・浴室乾燥機 ・ウッドデッキ・駐車場（4台） ",
    },
    model3: {
      id: "model3",
      name: "モデル住宅C",
      price: "",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "3LDK",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "08.jpg",
      thumbnail: [],
      archive: [
        [
          "01.jpg",
          "開放的なリビングダイニングは、扉を開くことで和室とひとつなぎとなり、より広々とした空間に。",
        ],
        ["02.jpg", "ゆったりとおくつろぎいただける畳の空間。"],
        ["03.jpg", "家族との会話が弾む、対面型システムキッチン。"],
        ["04.jpg", "キッチンには、収納スペースが備え付けてあります。"],
        ["05.jpg", "システムバスも完備。"],
        ["06.jpg", ""],
        ["07.jpg", ""],
        ["08.jpg", ""],
      ],
      maincopy: "家族の距離が近づく、風通しのよい住まい。",
      contents:
        "リビングダイニングと和室がひとつなぎになる間取りで、家族全員が同じ空間でゆっくりとくつろげます。全居室に収納スペースを完備。利便性の高い立地で、快適にお過ごしいただける住まいです。 ",
      detail: "",
      equip:
        "九州電力・省エネガス給湯器・暖房便座ウォシュレット・ガスコンロ・食器洗い機・浴室暖房・駐車場（4台）",
    },
    model4: {
      id: "model4",
      name: "モデル住宅D",
      price: "",
      category: "住宅",
      status: 0, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "3LDK",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "08.jpg",
      thumbnail: [],
      archive: [
        [
          "01.jpg",
          "開放感ある高い天井と、採光窓が、広々とした明るい空間を生み出します。",
        ],
        ["02.jpg", "扉を開放することで、和室とリビングをひとつなぎに。"],
        ["03.jpg", "キッチンには、収納スペースが備え付けてあります。"],
        ["04.jpg", "オール電化を採用した、安心・安全なキッチン。"],
        ["05.jpg", "システムバスも完備。"],
        ["06.jpg", ""],
        ["07.jpg", ""],
        ["08.jpg", ""],
      ],
      maincopy: "広々とした空間に光めぐる、明るい住まい。",
      contents:
        "生活設備を２Fに配置。高い天井と採光窓で開放的で明るい空間を作りました。リビングダイニングと和室がひとつなぎになる間取りで、家族全員が同じ空間でゆっくりとくつろげます。全居室に収納スペースを完備。利便性の高い立地で、快適にお過ごしいただける住まいです。  ",
      detail: "",
      equip:
        "オール電化・エコキュート・暖房便座ウォシュレット・IHクッキングヒーター・食器洗い機・駐車場（3台） ",
    },
  },
  const: {
    tomioka1a: {
      id: "tomioka1a",
      name: "苓北町富岡新築",
      price: "--",
      category: "住宅",
      status: 2, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "--",
      thumbnail: [],
      archive: [],
      maincopy: "現在建設中の物件です。お気軽にお問い合わせください",
      contents: "",
      detail: "",
      equip: "",
    },
    kitahara2a: {
      id: "kitahara2a",
      name: "北原町新築",
      price: "--",
      category: "住宅",
      status: 2, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "--",
      thumbnail: [],
      archive: [],
      maincopy: "現在建設中の物件です。お気軽にお問い合わせください",
      contents: "",
      detail: "",
      equip: "",
    },
    kitahara2b: {
      id: "kitahara2b",
      name: "北原町新築",
      price: "--",
      category: "住宅",
      status: 2, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "--",
      thumbnail: [],
      archive: [],
      maincopy: "現在建設中の物件です。お気軽にお問い合わせください",
      contents: "",
      detail: "",
      equip: "",
    },

    jikibac1: {
      id: "jikibac1",
      name: "亀場町食場新築",
      price: "--",
      category: "住宅",
      status: 2, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "--",
      thumbnail: [],
      archive: [],
      maincopy: "現在建設中の物件です。お気軽にお問い合わせください",
      contents: "",
      detail: "",
      equip: "",
    },
    jikibac2: {
      id: "jikibac2",
      name: "亀場町食場新築",
      price: "--",
      category: "住宅",
      status: 2, //1:販売中 0:売約済 2:建設中
      address: "",
      madori: "",
      tatemono: "--",
      tochi: "--",
      mainimg: "main.jpg",
      headimg: "--",
      thumbnail: [],
      archive: [],
      maincopy: "現在建設中の物件です。お気軽にお問い合わせください",
      contents: "",
      detail: "",
      equip: "",
    },
  },
};

export default homelist;
